import React from 'react';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';

import { Badge } from './Badge';
import { useGlobalData } from 'lib/hooks/sitecore/useGlobalData';
import { RecipeResponse } from 'lib/services/models/content-response';

export function BadgeWrapper() {
  const { sitecoreContext } = useSitecoreContext();
  const { siteName } = useGlobalData();

  return (
    <Badge
      recipe={sitecoreContext.contentItem as RecipeResponse}
      siteName={siteName}
      siteSettings={sitecoreContext.siteSettings}
    />
  );
}

export const Default = BadgeWrapper;
